import React from 'react';
import './Epost.css';

const epost = 'btynning@gmail.com';
const url = 'mailto:' + epost + '?subject=Tilbakemelding 7 trinn til Utdanning&body=Hvis teknisk feil, oppgi hvilken type enhet du bruker: ';

const Epost = () => <div className="epost"><a href={url} className="tekst">Gi Tilbakemelding(@)</a></div>

export default Epost